import { Typography } from "@kelp-dao/kernel-design-system";
import { CaretRightIcon } from "@phosphor-icons/react";
import Link from "next/link";
import { useRouter } from "next/router";
import { useMemo } from "react";
import { BW_VARIANT, TBW_VARIANT } from "./types";

interface PathData {
  label: string;
  path: string;
  isActive?: boolean;
}

type BreadCrumProps = {
  variant: TBW_VARIANT;
  data?: PathData[];
  className?: string;
};

const BreadCrum = ({ variant, className }: BreadCrumProps) => {
  const router = useRouter();
  const agETHJourney = variant === BW_VARIANT.AGETH;

  const breadcrumbData = useMemo(() => {
    if (!agETHJourney) return [];

    // Revisit the path later

    return [
      {
        label: "All vaults",
        path: "/gain",
        isActive: false,
      },
      {
        label: "agETH vault",
        path: "/gain/airdrop-gain",
        isActive: false,
      },
      {
        label: "Bridge & Wrap agETH",
        path: router.asPath,
        isActive: true,
      },
    ];
  }, [agETHJourney, router.asPath]);

  if (!agETHJourney || breadcrumbData.length === 0) {
    return null;
  }

  return (
    <div
      className={`flex items-center gap-[6px] text-sm justify-center md:justify-start ${className}`}
    >
      {breadcrumbData.map((item, index) => (
        <div key={item.path} className="flex items-center">
          {index > 0 && (
            <CaretRightIcon className="text-subbrand-primary mr-[6px]" />
          )}
          {item.isActive ? (
            <Typography
              variant="small"
              type="body"
              className="text-text-secondary"
            >
              {item.label}
            </Typography>
          ) : (
            <Link href={item.path}>
              <Typography
                variant="small"
                type="body"
                className="text-text-primary hover:text-text-secondary transition-colors cursor-pointer"
              >
                {item.label}
              </Typography>
            </Link>
          )}
        </div>
      ))}
    </div>
  );
};

export default BreadCrum;
